import { Avatar, Box, Grid, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { PurpleWarning, Warning } from 'Images';
import { isDesktop } from 'react-device-detect';

export const HeaderNote = () => {
  return (
    <Grid
      item
      container
      alignItems='center'
      gap={1}
      flexWrap='nowrap'
      sx={{
        border: '1px solid',
        borderColor: 'primary.shade_200',
        backgroundColor: 'primary.shade_50',
        borderRadius: '12px',
        p: '23px 27px',
        m: '32px 0',
      }}
    >
      <Grid
        item
        sx={{
          alignSelf: isDesktop ? 'center' : 'start',
          position: isDesktop ? undefined : 'relative',
          top: isDesktop ? undefined : '5px',
        }}
      >
        <Avatar
          alt={''}
          src={PurpleWarning}
          sx={{
            width: '22px',
            height: '22px',
            alignSelf: 'center',
          }}
        />
      </Grid>
      <Grid item>
        <Typography variant='body2' component='p' tabIndex={0}>
          {Dictionary[DICTIONARY.Equipment].createOrder.headerNote}
        </Typography>
      </Grid>
    </Grid>
  );
};
